import m from 'mithril'

type Attrs = { title: string; onclose: () => void }

/** A bottom sheet: slides up over the page, closes on the backdrop, the X, or Escape. */
export const Sheet: m.ClosureComponent<Attrs> = () => {
  let close: () => void = () => {}
  const onKey = (event: KeyboardEvent) => {
    if (event.key === 'Escape') close()
  }

  return {
    oncreate: ({ attrs, dom }) => {
      close = attrs.onclose
      document.addEventListener('keydown', onKey)
      document.body.classList.add('sheet-open')
      ;(dom.querySelector('.sheet') as HTMLElement | null)?.focus()
    },
    onupdate: ({ attrs }) => {
      close = attrs.onclose
    },
    onremove: () => {
      document.removeEventListener('keydown', onKey)
      document.body.classList.remove('sheet-open')
    },
    view: ({ attrs, children }) =>
      m('div.sheet-layer', [
        m('div.sheet-backdrop', { onclick: attrs.onclose }),
        m('div.sheet', { role: 'dialog', 'aria-modal': 'true', 'aria-label': attrs.title, tabindex: -1 }, [
          m('div.sheet-handle', { 'aria-hidden': 'true' }),
          m('div.sheet-head', [
            m('h2', attrs.title),
            m(
              'button.sheet-close',
              { type: 'button', 'aria-label': 'Close', onclick: attrs.onclose },
              m(
                'svg',
                {
                  viewBox: '0 0 24 24',
                  width: 20,
                  height: 20,
                  fill: 'none',
                  stroke: 'currentColor',
                  'stroke-width': 2,
                  'stroke-linecap': 'round',
                  'aria-hidden': 'true',
                },
                m('path', { d: 'M6 6l12 12M18 6L6 18' }),
              ),
            ),
          ]),
          m('div.sheet-body', children),
        ]),
      ]),
  }
}
